module.exports = __webpack_public_path__ + "img/plane-engines.15b23f5e.svg";